module.exports = __webpack_public_path__ + "static/media/adultos-mayores.67d2d603.svg";